// extracted by mini-css-extract-plugin
export default {"ReleaseNotes":"ReleaseNotes_ReleaseNotes__NKVy+"};